<template>
 <div class="footer">
    <div class="gotop" v-show="gotop" @click="toTop">
      <img src="@/assets/fanhui.png" alt="">
    </div>
</div>
</template>
 <script>
  export default {
  data() {
    return {
      gotop: false
    };
  },
  mounted() {
　　// 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
        //注意不同浏览器之间的兼容性
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
        scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        // 实现滚动效果 
        const timeTop = setInterval(() => {
            document.body.scrollTop = document.documentElement.scrollTop = top -= 100;
            if (top <= 0) {
            clearInterval(timeTop);
            }
        }, 0.1);
    }
  }
}
</script>

<style lang="less" scoped>
.gotop{
    border: 1xp solid #7788cc;
    font-size: 14px;
    float: right;
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background-color: #eee;
    text-align: center;
    img{
      width: 80%;
      cursor:pointer;
    }
}
</style>
